
import state from './moduleWeentregaState.js'
import mutations from './moduleWeentregaMutations.js'
import actions from './moduleWeentregaActions.js'
import getters from './moduleWeentregaGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
